<template>
  <div class="toggle">
    <div class="toggle-inner" @click.self="onClick">
      <div
        class="draggable"
        :class="{
          'draggable--savings': showPotenitialSavings,
          'draggable--empty': isAnswerEmpty,
        }"
        @mousedown.prevent="dragStart"
        @touchstart.prevent="dragStart"
        :style="style"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
    },
    showPotenitialSavings: {
      type: Boolean,
    },
    isAnswerEmpty: {
      type: Boolean,
    },
  },
  data() {
    return {
      width: 160,
      widthMax: 128,
      widthButton: 32,
      state: "",
      pressed: 0,
      position: 0,
    };
  },
  mounted() {
    this.setToggleState("");
    this.widthMax = this.width - this.widthButton;
  },
  computed: {
    style() {
      return {
        left: `${this.position}px`,
      };
    },
  },
  watch: {
    position() {
      this.state = this.position >= this.widthMax / 2 ? "No" : "Yes";
    },
  },
  methods: {
    onClick(e) {
      let pos;
      if (e.clientX) {
        //mouse event
        pos = e.clientX - this.$el.getBoundingClientRect().left;
      } else {
        //touch event
        pos = e.touches[0].clientX - this.$el.getBoundingClientRect().left;
      }
      const percent = (pos / this.widthMax) * 100;

      if (percent >= this.widthMax / 2) {
        this.setToggleState("No");
      } else {
        this.setToggleState("Yes");
      }

      this.emit();
    },
    setToggleState(state) {
      this.state = state;
      if (state === "") {
        this.position = this.widthMax / 2;
      } else {
        this.position = state == "Yes" ? 0 : this.widthMax;
      }
    },
    draggingMouse(e) {
      // this is the mouse event
      const pos = e.clientX - this.$el.getBoundingClientRect().left;
      const percent = (pos / this.widthMax) * 100;
      this.position =
        percent <= 0 ? 0 : percent >= this.widthMax ? this.widthMax : percent;
    },
    draggingTouch(e) {
      const pos = e.touches[0].clientX - this.$el.getBoundingClientRect().left;
      const percent = (pos / this.widthMax) * 100;
      this.position =
        percent <= 0 ? 0 : percent >= this.widthMax ? this.widthMax : percent;
    },
    dragStart(e) {
      this.startTimer();
      window.addEventListener("mousemove", this.draggingMouse);
      window.addEventListener("touchmove", this.draggingTouch);
      window.addEventListener("mouseup", this.dragStop);
      window.addEventListener("touchend", this.dragStop);
    },
    dragStop() {
      window.removeEventListener("mousemove", this.draggingMouse);
      window.removeEventListener("touchmove", this.draggingTouch);
      window.removeEventListener("mouseup", this.dragStop);
      window.removeEventListener("touchend", this.dragStop);
      this.resolvePosition();
      clearInterval(this.$options.interval);
      // if (this.pressed < 30) {
      //   this.toggle(!this.state);
      // }
      this.pressed = 0;
      this.emit();
    },
    startTimer() {
      this.$options.interval = setInterval(() => {
        this.pressed++;
      }, 1);
    },
    resolvePosition() {
      this.position = this.state == "Yes" ? 0 : this.widthMax;
    },
    emit() {
      this.$emit("input", this.state);
    },
  },
};
</script>
<style lang="scss">
$width: 160px;
$background: #fff;
$background-active: #fff;
$border-color: black;
$button-size: 32px;

.toggle {
  display: inline-block;
  background: $background;
  border: 2px solid $border-color;
  border-radius: 200px;
  padding: 2px 4px;
  transition: background 0.6s;

  .toggle-inner {
    position: relative;
    width: $width;
    height: $button-size + 4px;
    cursor: pointer;
  }

  .draggable {
    position: absolute;
    top: 2px;
    width: $button-size;
    height: $button-size;
    background: #2393ff;
    border-radius: 100%;

    &--empty {
      background: #a8a8a8;
    }

    &--savings {
      background: #04b776;
    }
  }

  &.active {
    background: $background-active;
    transition: background 0.6s;
  }
}
.switches {
  margin-right: 30px;
  position: relative;
}

pre {
  margin: 0;
  background: #513d56;
  color: #efefef;
  padding: 20px;
  border-radius: 6px;
  width: 200px;
}
</style>
